export type AudioInputDevice = {
   id: string;
   label: string;
};

export const listAudioInputDevices = async (): Promise<AudioInputDevice[]> => {
   const devices = await navigator.mediaDevices.enumerateDevices();

   return devices
      .filter((device) => device.kind === 'audioinput' && device.deviceId !== '')
      .map((device) => ({ id: device.deviceId, label: device.label }));
};

const DEFAULT_AUDIO_INPUT_DEVICE_ID = 'default';

export const getDefaultAudioInputDevice = (devices: AudioInputDevice[]): AudioInputDevice | null => {
   return devices.find((device) => device.id === DEFAULT_AUDIO_INPUT_DEVICE_ID) ?? devices[0] ?? null;
};

export const resolveAudioInputDeviceConstraint = async (
   deviceId: string | null
): Promise<ConstrainDOMString | undefined> => {
   if (deviceId === null) {
      return undefined;
   }

   const devices = await listAudioInputDevices();

   return devices.some((device) => device.id === deviceId) ? { exact: deviceId } : undefined;
};
